import * as React from "react";


interface LanguageMultiSelectProps {
    /** A space-delimited list of class names to pass along to a child element. */
    className?: string;

    selectedLanguages: string[];
    onChange: (selectedLanguages: string[]) => void;
}

interface LanguageMultiSelectState {
}

const ALL_LANGUAGES = [
    "Albanian",
    "Arabic",
    "Armenian",
    "Bengali",
    "Bulgarian",
    "Cantonese",
    "Chinese",
    "Creole",
    "Danish",
    "Dutch",
    "English",
    "Estonian",
    "Farsi",
    "Filipino",
    "French",
    "Fukkianese",
    "Fula/Fulani",
    "Fuzhounese",
    "Georgian",
    "German",
    "Ghana",
    "Greek",
    "Hakka",
    "Hebrew",
    "Hindi",
    "Hungarian",
    "Italian",
    "Japanese",
    "Korean",
    "Krio",
    "Kyrgyz",
    "Mandarin",
    "Pashto",
    "Persian",
    "Polish",
    "Portuguese",
    "Punjabi",
    "Romanian",
    "Russian",
    "Shanghainese",
    "Soninke",
    "Spanish",
    "Swahili",
    "Tagalog",
    "Taishanese",
    "Taiwanese",
    "Turkish",
    "Twi",
    "Ukrainian",
    "Urdu",
    "Uzbek",
    "Vietnamese",
    "Yiddish",
];

export class LanguageMultiSelect extends React.Component<LanguageMultiSelectProps, LanguageMultiSelectState> {
    constructor(props: LanguageMultiSelectProps) {
        super(props);

        this.state = {};
    }

    handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const languages: string[] = [];
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < e.target.selectedOptions.length; ++i) {
            languages.push(e.target.selectedOptions[i].value);
        }
        if (setsEqual(this.props.selectedLanguages, languages)) {
            return;
        }

        console.log("languages", languages);
        this.props.onChange(languages);
    }

    render() {
        return (
            <select
                className={"form-control"}
                required={true}
                onChange={this.handleChange}
                multiple={true}
                value={this.props.selectedLanguages}
            >
                {ALL_LANGUAGES.map((lang) => {
                    return (
                        <option
                            value={lang}
                            key={lang}
                        >
                            {lang}
                        </option>
                    );
                })}
            </select>
        );
    }
}

/**
 * Do both arrays contain the same elements?
 */
function setsEqual<T>(a: T[], b: T[]): boolean {
    if (a.length !== b.length) {
        return false;
    }
    for (const i of a) {
        if (b.indexOf(i) < 0) {
            return false;
        }
    }
    return true;
}



// WEBPACK FOOTER //
// ./src/components/widgets/LanguageMultiSelect.tsx